import { render, staticRenderFns } from "./addcar.vue?vue&type=template&id=62b34b60&"
import script from "./addcar.vue?vue&type=script&lang=js&"
export * from "./addcar.vue?vue&type=script&lang=js&"
import style0 from "./addcar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports